/* eslint-disable no-unused-vars */
import React from 'react';
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const StatisticRow = ({ STATISTIC_ROW_HEIGHT, allStatistic, renderCols }) => {
  return (
    <TableRow height={STATISTIC_ROW_HEIGHT}>
      <Th>
        <LeftParagraph height={STATISTIC_ROW_HEIGHT}>Total:</LeftParagraph>
      </Th>
      {renderCols.map((fieldName) => {
        return (
          <Th key={fieldName}>
            <RightParagraphs height={STATISTIC_ROW_HEIGHT}>
              {allStatistic[fieldName.toLowerCase()].toLocaleString()}
            </RightParagraphs>
          </Th>
        );
      })}
      {/* empty col to fill the rest of space */}
      <Th>
        <RightParagraphs height={STATISTIC_ROW_HEIGHT} />
      </Th>
    </TableRow>
  );
};

const TableRow = styled.tr`
  height: ${({ height }) => `${height}px`};
  background: ${Palette.PrimaryGray._100};
`;

const Th = styled.th`
  padding: 0;
`;

const LeftParagraph = styled.p`
  display: flex;
  align-items: center;
  border-right: 1px solid ${Palette.PrimaryGray._200};
  color: ${Palette.PrimaryGray._500};
  padding: 0 0 0 16px;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  height: ${({ height }) => `${height}px`};
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;

const RightParagraphs = styled.p`
  color: ${Palette.PrimaryGray._700};
  padding: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => `${height}px`};
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;
